import type { ComponentProps } from 'react';
import { Avatar as RadixAvatar } from '@radix-ui/themes';
import { cn } from '@/lib/utils';

interface AvatarProps extends Omit<ComponentProps<typeof RadixAvatar>, 'fallback'> {
  name?: string;
  fallback?: ComponentProps<typeof RadixAvatar>['fallback'];
  border?: boolean;
}

export function Avatar({ name, className, fallback, border, style, ...props }: AvatarProps) {
  const initial = name?.trim().charAt(0).toUpperCase() || '?';

  return (
    <RadixAvatar
      {...props}
      fallback={fallback ?? initial}
      className={cn('shrink-0', border && 'border', className)}
      style={{
        ...(border && { borderColor: 'var(--accent-9)' }),
        ...style,
      }}
    />
  );
}

export type { AvatarProps };
